import React, { Fragment, useContext } from 'react';
import ShowModalContext from '../../molecules/Modal/ShowModalContext';
import { PageFooter, PageFooterLinks, PageFooterText, PageFooterTextSm } from './BankForm.style';
import AMPIdentifier from '../../contexts/AMPIdentifier';
import { PRIVACY_URL, IMPRINT_URL } from '../../Constants';


export default () => {
  const isAMP = useContext(AMPIdentifier);
  const { show } = useContext(ShowModalContext);
  const showURL = url => () => show(url);

  return (
    <PageFooter>
      <PageFooterTextSm>
        © {new Date().getFullYear()} FINANZCHECK.de
        <br />
        Admiralitätstraße 60 - 20459 Hamburg
      </PageFooterTextSm>
      <PageFooterText>
        © {new Date().getFullYear()} FINANZCHECK.de • Admiralitätstraße 60 • 20459 Hamburg
      </PageFooterText>
      <PageFooterLinks>
        {isAMP ? (
          <Fragment>
            <a
              target="_blank"
              rel="noreferrer noopener nofollow"
              href={PRIVACY_URL}
            >
              Datenschutz
            </a>
            <a
              target="_blank"
              rel="noreferrer noopener nofollow"
              href={IMPRINT_URL}
            >
              Impressum
            </a>
          </Fragment>
        ) : (
          <Fragment>
            <button
              type="button"
              onClick={showURL(PRIVACY_URL)}
            >
              Datenschutz
            </button>
            <button
              type="button"
              onClick={showURL(IMPRINT_URL)}
            >
              Impressum
            </button>
          </Fragment>
        )}
      </PageFooterLinks>
    </PageFooter>
  );
};
